import MainEventDetail from "../components/event-detail/main-event-detail";

function EventMasterDetail() {
  return (
    <div className="w-[97%] mx-auto">
        
      <MainEventDetail />
    </div>
  );
}

export default EventMasterDetail;
